import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import NotificationForm from '../components/NotificationForm';
import { loadData, updateData } from 'Actions/notification';
import { pageTitleDecorator } from 'Decorators';
import IconCard from 'Common/Cards/IconCard.jsx';
import Header from 'Components/Header/Header';

@connect(
    store => ({
        data: store.notificationsData.data,
    }),
    dispatch => ({
        loadData: id => dispatch(loadData(id)),
        updateData: data => dispatch(updateData(data)),
    })
)
@pageTitleDecorator('notification.edit')
export default class Notification extends PureComponent {
    /**
     * @type {Object}
     */
    static propTypes = {
        data: PropTypes.object,
        updateData: PropTypes.func.isRequired,
        loadData: PropTypes.func.isRequired,
        id: PropTypes.string.isRequired,
    };

    /**
     * @type {Object}
     */
    static contextTypes = {
        intl: PropTypes.object.isRequired,
    };

    componentDidMount() {
        const { loadData, id } = this.props;
        loadData(id);
    }

    render() {
        const { updateData, data, id } = this.props;

        return (
            <div>
                <Header title="title.notification.edit" />
                <IconCard
                    backButton={{
                        to: '/settings/notifications',
                        title: 'button.to.notifications',
                    }}
                    content={
                        <NotificationForm
                            onSubmit={ updateData }
                            initialValues={ data }
                            id={ id }
                        />
                    }
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/Settings/containers/Notification.jsx